export const ROUTE_SAVED_TARGETING_PROFILES = '/targeting-profiles';
export const SUBROUTE_EDITOR = '/editor';

export const TARGETING_PROFILES_QUERY_KEY_PREFIX = 'targeting-profiles';
export const TARGETING_PROFILE_USAGE_QUERY_KEY_PREFIX =
  'targeting-profile-usage';

export const LIST_BREADCRUMB_TEXT = 'targeting profiles';
